/**
 * The URL is the whole access story for now (§7 phase 3): `?w=<workspace>` picks
 * the document, `&room=<room>` picks the room. Keeping the active room in the
 * URL rather than in the document means switching rooms on a laptop does not
 * yank the phone to a different room, and it survives reload without inventing
 * a second storage mechanism next to §4.3's "IndexedDB only".
 */
const WORKSPACE_PARAM = "w";
const ROOM_PARAM = "room";
const SYNC_PARAM = "sync";

export function currentWorkspaceId(): string {
  const url = new URL(window.location.href);
  const existing = url.searchParams.get(WORKSPACE_PARAM);
  if (existing !== null && existing !== "") return existing;
  const created = crypto.randomUUID();
  url.searchParams.set(WORKSPACE_PARAM, created);
  window.history.replaceState(null, "", url);
  return created;
}

export function currentRoomId(): string | null {
  return new URL(window.location.href).searchParams.get(ROOM_PARAM);
}

export function setCurrentRoomId(id: string): void {
  const url = new URL(window.location.href);
  if (url.searchParams.get(ROOM_PARAM) === id) return;
  url.searchParams.set(ROOM_PARAM, id);
  window.history.replaceState(null, "", url);
}

/**
 * `&sync=<url>` points this tab at a particular relay, and `&sync=off` keeps the
 * workspace local. Both exist so acceptance tests can drive two devices against
 * a server they start and stop themselves; the default is the built-in relay.
 */
export function currentSyncUrl(): string | false | undefined {
  const value = new URL(window.location.href).searchParams.get(SYNC_PARAM);
  if (value === null || value === "") return undefined;
  return value === "off" ? false : value;
}
